/**
 * Les mots de l'accueil, la carte de ta vie (chantier `navigation`, 02, maquette du carnet
 * `accueil.html`) : le bonjour, la bulle du centre, les galets des projets et les quatre blocs.
 */

/** L'heure où « Bonjour » devient « Bonsoir ». */
export const HEURE_DU_SOIR = 18;

/** « Bonjour » avant 18 h, « Bonsoir » après, sans prénom : le compte ne le connaît pas. */
export function salutation(heure: number): string {
  return heure < HEURE_DU_SOIR ? 'Bonjour' : 'Bonsoir';
}

export const TOI = 'Toi';
export const LA_CARTE_DE_TA_VIE = 'La carte de ta vie';

/** « 7 faites sur 18 » : l'avancement d'un projet, jamais en pourcentage. */
export function faitesSur(faites: number, total: number): string {
  return `${faites} ${faites > 1 ? 'faites' : 'faite'} sur ${total}`;
}
export const PROCHAINE = 'Prochaine';

export const TU_PEUX_FAIRE_MAINTENANT = 'Tu peux faire maintenant';
export const CE_QUI_COINCE = 'Ce qui coince';
export const J_ATTENDS = 'J’attends';
export const CA_ARRIVE = 'Ça arrive';
export const SEPT_JOURS = '7 jours';

/** Un bloc vide le dit en une ligne. */
export const RIEN_A_FAIRE_TOUT_DE_SUITE = 'Rien à faire tout de suite.';
export const RIEN_NE_COINCE = 'Rien ne coince.';
export const RIEN_N_ARRIVE = 'Rien de daté dans les sept jours.';

/** « retient 8 » : ce qu'un débloquant libère quand il est fait. */
export function retient(n: number): string {
  return `retient ${n}`;
}

/**
 * Depuis combien de temps une réponse est attendue : « 3 jours », « 12 jours, à relancer ».
 * `jours` est `null` quand on ne sait pas quand la demande est partie.
 */
export function attendDepuis(jours: number | null, aRelancer: boolean): string {
  const depuis =
    jours === null ? null : jours <= 0 ? 'Partie aujourd’hui' : `${jours} ${jours > 1 ? 'jours' : 'jour'}`;
  if (!aRelancer) return depuis ?? 'En cours';
  return depuis ? `${depuis}, à relancer` : 'À relancer';
}
